import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { ProjectDashboardRevision } from '../projectDashboardTypes';

const defaultRevisionValue: ProjectDashboardRevision = {
  data: undefined,
  status: {
    loading: false,
    error: undefined,
  },
  isSteady: false,
};

/** @deprecated Use `useCurrentRevision` hook instead for components within the project dashboard. */
export const RevisionContext = createContext<ProjectDashboardRevision>(defaultRevisionValue);

/** @deprecated Use `useCurrentRevision` hook instead for components within the project dashboard. */
export const useRevision = () => useContext(RevisionContext);

type RevisionProviderProps = {
  children: ReactNode;
  value: ProjectDashboardRevision;
};

/** @deprecated Consumers should use `useCurrentRevision` instead. Still used internally by RevisionContainer during migration. */
export const RevisionProvider = ({ children, value }: RevisionProviderProps) => (
  <RevisionContext.Provider value={value}>
    {children}
  </RevisionContext.Provider>
);

export default RevisionProvider;
